// Define selectors and classes as top-level constants for reuse
const SH_COLOR_COLLECTION_CLASSES = {
  productGridContainer: 'js-product-grid-container',
  loadMoreButton: 'js-load-more-button',
  productGridWrapper: 'js-product-grid-wrapper',
};
const SH_COLOR_COLLECTION_SELECTORS = {
  productGridContainer: '.js-product-grid-container',
  loadMoreButton: '.js-load-more-button',
  productGridWrapper: '.js-product-grid-wrapper',
};

class ShColorCollection extends HTMLElement {
  constructor() {
    super();
    this.classes = SH_COLOR_COLLECTION_CLASSES;
    this.selectors = SH_COLOR_COLLECTION_SELECTORS;
  }

  connectedCallback() {
    console.log('sh-color-collection web component connected');
    this._bindLoadMore();
  }

  disconnectedCallback() {
    console.log('sh-color-collection web component disconnected');
  }

  _bindLoadMore() {
    this.addEventListener('click', async (event) => {
      const button = event.target.closest(this.selectors.loadMoreButton);
      if (!button || !this.contains(button)) return;

      // Get the closest product grid container and wrapper
      const productGridContainer = button.closest(this.selectors.productGridContainer);
      if (!productGridContainer) return;
      const productGridWrapper = productGridContainer.querySelector(this.selectors.productGridWrapper);
      if (!productGridWrapper) return;

      // Get data attributes
      let nextPage = parseInt(button.getAttribute('data-next-page'), 10);
      let collectionUrl = button.getAttribute('data-collection-url');

      // Build the next page URL (do not increment yet)
      let newCollectionUrl = collectionUrl.replace(/([?&]page=)(\d+)/, (match, p1, p2) => p1 + p2);
      // If no page param, add it
      if (!/([?&]page=)/.test(newCollectionUrl)) {
        newCollectionUrl += (newCollectionUrl.includes('?') ? '&' : '?') + 'page=' + nextPage;
      } else {
        newCollectionUrl = newCollectionUrl.replace(/([?&]page=)(\d+)/, (match, p1, p2) => p1 + nextPage);
      }

      // Disable button while loading
      button.disabled = true;
      button.textContent = 'Loading...';
      
      // Fetch the next page HTML
      try {
        console.log('Fetching URL:', newCollectionUrl);
        const response = await fetch(newCollectionUrl);
        if (!response.ok) throw new Error('Network response was not ok');
        const responseText = await response.text();
        const parser = new DOMParser();
        const fetchedDocument = parser.parseFromString(responseText, 'text/html');
        // Find the correct container by id
        const currentContainerId = productGridContainer.id;
        const newContainer = fetchedDocument.getElementById(currentContainerId);
        if (newContainer) {
          const newGridWrapper = newContainer.querySelector(this.selectors.productGridWrapper);
          if (newGridWrapper) {
            const newItems = Array.from(newGridWrapper.querySelectorAll('.grid__item'));
            console.log('New product grid items:', newItems);
            if (newItems.length > 0) {
              newItems.forEach(item => productGridWrapper.appendChild(item));
              // Only increment page and update data attributes after successful append
              const incrementedPage = nextPage + 1;
              button.setAttribute('data-next-page', incrementedPage);
              // Update collectionUrl's page param for next time
              let updatedCollectionUrl = collectionUrl;
              if (!/([?&]page=)/.test(updatedCollectionUrl)) {
                updatedCollectionUrl += (updatedCollectionUrl.includes('?') ? '&' : '?') + 'page=' + incrementedPage;
              } else {
                updatedCollectionUrl = updatedCollectionUrl.replace(/([?&]page=)(\d+)/, (match, p1, p2) => p1 + incrementedPage);
              }
              button.setAttribute('data-collection-url', updatedCollectionUrl);
              // Re-enable button
              button.disabled = false;
              button.textContent = 'Load More';
              return;
            }
          }
        }
        // If no new items, disable the button and update text
        button.disabled = true;
        button.textContent = 'No more products';
      } catch (error) {
        console.error('Error loading more products:', error);
        button.disabled = true;
        button.textContent = 'No more products';
      }
    });
  }
}

// Register the custom element
customElements.define('sh-color-collection', ShColorCollection);

// Initialize on DOM content loaded
document.addEventListener('DOMContentLoaded', function() {
  console.log('DOM loaded, sh-color-collection web component is ready');
  // Auto-initialize any existing sh-color-collection elements
  const existingElements = document.querySelectorAll('sh-color-collection');
  existingElements.forEach(element => {
    if (!element.shadowRoot) {
      // If for some reason the element wasn't properly initialized
      console.log('Re-initializing sh-color-collection element');
    }
  });
});

// Also initialize on window load as a fallback
window.addEventListener('load', function() {
  console.log('Window loaded, sh-color-collection web component fully ready');
});

// Check for disabling auto-load based on URL
(function() {
  const search = window.location.search.toLowerCase();
  const shouldDisableAutoLoad = search.includes('sort_by') || search.includes('fitments_filter');
  if (shouldDisableAutoLoad) {
    // Hide all load more buttons
    document.addEventListener('DOMContentLoaded', function() {
      document.querySelectorAll(SH_COLOR_COLLECTION_SELECTORS.loadMoreButton).forEach(btn => {
        btn.style.display = 'none';
      });
    });
    // Set global flag to disable auto-fetch
    window._shColorCollectionDisableAutoLoad = true;
    return;
  }
})();

// --- AUTO-ASYNC LOAD ALL SECTIONS UNTIL COMPLETE ---
(function() {
  if (window._shColorCollectionDisableAutoLoad) return;

  // Helper to get all .js-product-grid-container and their buttons
  function getAllSectionButtons() {
    const containers = Array.from(document.querySelectorAll(SH_COLOR_COLLECTION_SELECTORS.productGridContainer));
    // Prioritize above-the-fold: sort by vertical position
    containers.sort((a, b) => a.getBoundingClientRect().top - b.getBoundingClientRect().top);
    return containers.map(container => container.querySelector(SH_COLOR_COLLECTION_SELECTORS.loadMoreButton)).filter(Boolean);
  }

  // Async function to load all pages for a section
  async function loadAllPagesForSection(button) {
    let keepLoading = true;
    while (keepLoading && button && !button.disabled) {
      // Simulate the Load More logic
      const productGridContainer = button.closest(SH_COLOR_COLLECTION_SELECTORS.productGridContainer);
      if (!productGridContainer) break;
      const productGridWrapper = productGridContainer.querySelector(SH_COLOR_COLLECTION_SELECTORS.productGridWrapper);
      if (!productGridWrapper) break;
      let nextPage = parseInt(button.getAttribute('data-next-page'), 10);
      let collectionUrl = button.getAttribute('data-collection-url');
      let newCollectionUrl = collectionUrl.replace(/([?&]page=)(\d+)/, (match, p1, p2) => p1 + p2);
      if (!/([?&]page=)/.test(newCollectionUrl)) {
        newCollectionUrl += (newCollectionUrl.includes('?') ? '&' : '?') + 'page=' + nextPage;
      } else {
        newCollectionUrl = newCollectionUrl.replace(/([?&]page=)(\d+)/, (match, p1, p2) => p1 + nextPage);
      }
      try {
        console.log('[sh-collection-color] Fetching section page:', newCollectionUrl);
        const response = await fetch(newCollectionUrl);
        if (!response.ok) throw new Error('Network response was not ok');
        const responseText = await response.text();
        const parser = new DOMParser();
        const fetchedDocument = parser.parseFromString(responseText, 'text/html');
        const currentContainerId = productGridContainer.id;
        const newContainer = fetchedDocument.getElementById(currentContainerId);
        if (newContainer) {
          const newGridWrapper = newContainer.querySelector(SH_COLOR_COLLECTION_SELECTORS.productGridWrapper);
          if (newGridWrapper) {
            const newItems = Array.from(newGridWrapper.querySelectorAll('.grid__item'));
            if (newItems.length > 0) {
              newItems.forEach(item => {
                const newId = item.getAttribute('data-product-id');
                if (!newId) {
                  productGridWrapper.appendChild(item);
                  return;
                }
                const exists = productGridWrapper.querySelector('.grid__item[data-product-id="' + newId + '"]');
                if (!exists) {
                  productGridWrapper.appendChild(item);
                } else {
                  console.log('[sh-collection-color] Skipped duplicate product', newId);
                }
              });
              // Update button data attributes as if clicked
              const incrementedPage = nextPage + 1;
              button.setAttribute('data-next-page', incrementedPage);
              let updatedCollectionUrl = collectionUrl;
              if (!/([?&]page=)/.test(updatedCollectionUrl)) {
                updatedCollectionUrl += (updatedCollectionUrl.includes('?') ? '&' : '?') + 'page=' + incrementedPage;
              } else {
                updatedCollectionUrl = updatedCollectionUrl.replace(/([?&]page=)(\d+)/, (match, p1, p2) => p1 + incrementedPage);
              }
              button.setAttribute('data-collection-url', updatedCollectionUrl);
              // Continue loading
              continue;
            }
          }
        }
        // If no new items, stop loading
        keepLoading = false;
        button.disabled = true;
        button.textContent = 'No more products';
        console.log('[sh-collection-color] Section complete:', currentContainerId);
      } catch (error) {
        keepLoading = false;
        button.disabled = true;
        button.textContent = 'No more products';
        console.error('[sh-collection-color] Error loading section:', error);
      }
    }
  }

  // On DOMContentLoaded, start loading all sections in parallel
  function startAsyncLoadingAllSections() {
    const buttons = getAllSectionButtons();
    if (!buttons.length) return;
    // Parallel loading, prioritizing above-the-fold
    buttons.forEach(button => {
      loadAllPagesForSection(button);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startAsyncLoadingAllSections);
  } else {
    startAsyncLoadingAllSections();
  }
})();

// --- FILTER SYSTEM (SEPARATE FROM COLOR SYSTEM) ---
(function() {
  // IMMEDIATE FLICKER PREVENTION: Check URL and hide sections synchronously
  const urlParams = new URLSearchParams(window.location.search);
  const hasFilters = urlParams.has('filter.p.vendor') || 
                     urlParams.has('filter.p.product_type') || 
                     urlParams.has('filter.p.tag');
  
  if (hasFilters) {
    console.log('[sh-filter-system] Immediate flicker prevention - hiding color collection wrapper');
    
    // Add CSS to immediately hide the entire color collection wrapper
    const style = document.createElement('style');
    style.textContent = `
      .sh-color-collection-wrapper { display: none; }
      #sh-filtered-products { display: block; }
    `;
    
    // Add to head immediately, even before DOM is ready
    if (document.head) {
      document.head.appendChild(style);
    } else {
      // Fallback: add when head becomes available
      document.addEventListener('DOMContentLoaded', () => {
        document.head.appendChild(style);
      });
    }
  }

  // IMMEDIATE CHANGE LISTENERS - Attach as soon as script loads
  // Handle immediate UI changes when filters are changed
  function handleFilterUIChange() {
    console.log('[sh-filter-system] Handling immediate UI change for filter interaction');
    
    // Immediate UI update - hide color system, show filter system
    const colorCollectionWrapper = document.querySelector('.sh-color-collection-wrapper');
    if (colorCollectionWrapper) {
      colorCollectionWrapper.style.display = 'none';
    }
    
    const filterContainer = document.getElementById('sh-filtered-products');
    if (filterContainer) {
      filterContainer.style.display = 'block';
      
      // Show loading state immediately
      setTimeout(() => {
        const gridWrapper = filterContainer.querySelector('.js-product-grid-wrapper');
        if (gridWrapper && gridWrapper.children.length === 0) {
          gridWrapper.innerHTML = '<div class="loading-state" style="text-align: center; padding: 40px; grid-column: 1 / -1;"><p>Loading products...</p></div>';
        }
      }, 0);
    }
  }

  // Attach change listeners immediately (not waiting for DOM ready)
  document.addEventListener('change', function(event) {
    const target = event.target;
    
    // Handle vendor filter changes (all types)
    if (target.name === 'filter.p.vendor' || 
        target.name === 'filter.p.product_type' || 
        target.name === 'filter.p.tag' ||
        target.name === 'SortBy') {
      
      console.log('[sh-filter-system] IMMEDIATE filter change detected:', target.name, target.value);
      
      // Immediate UI update - no delays
      handleFilterUIChange();
      
      // Schedule filter processing after UI update
      scheduleFilterProcessing();
    }
  }, true); // Use capture phase for earliest possible detection

  // Attach form submission listener immediately  
  document.addEventListener('submit', function(event) {
    const form = event.target;
    const hasFilterInputs = form.querySelector('input[name^="filter.p."], select[name^="filter.p."], select[name="SortBy"]');
    if (hasFilterInputs) {
      console.log('[sh-filter-system] IMMEDIATE filter form submission detected');
      
      // Immediate UI update - no delays
      handleFilterUIChange();
      
      // Schedule filter processing after UI update
      scheduleFilterProcessing();
    }
  }, true); // Use capture phase for earliest possible detection

  // Debounced filter processing
  let filterProcessingTimeout = null;
  function scheduleFilterProcessing() {
    // Clear any existing timeout to debounce rapid changes
    if (filterProcessingTimeout) {
      clearTimeout(filterProcessingTimeout);
    }
    
    // Schedule processing after a short delay
    filterProcessingTimeout = setTimeout(() => {
      processFilterChange();
    }, 150); // 150ms debounce delay
  }

  // Process the actual filter change
  function processFilterChange() {
    console.log('[sh-filter-system] Processing filter change...');
    
    // Check if DOM is ready for processing
    if (document.readyState === 'loading') {
      // Wait for DOM ready if still loading
      document.addEventListener('DOMContentLoaded', () => {
        executeFilterChange();
      });
    } else {
      // DOM is ready, execute immediately
      executeFilterChange();
    }
  }

  // Execute the filter change logic
  function executeFilterChange() {
    if (hasActiveFilters()) {
      const filters = getActiveFilters();
      loadFilteredProducts(filters);
    } else {
      // No filters active - show color system
      showColorSystem();
    }
  }

  // Check if any supported filters are active in URL
  function hasActiveFilters() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.has('filter.p.vendor') || 
           urlParams.has('filter.p.product_type') || 
           urlParams.has('filter.p.tag') ||
           urlParams.has('sort_by');
  }

  // Get all active filters from URL
  function getActiveFilters() {
    const urlParams = new URLSearchParams(window.location.search);
    const filters = {};
    
    // Get vendor filters
    const vendorFilters = urlParams.getAll('filter.p.vendor');
    if (vendorFilters.length > 0) {
      filters.vendor = vendorFilters;
    }
    
    // Get product type filters
    const typeFilters = urlParams.getAll('filter.p.product_type');
    if (typeFilters.length > 0) {
      filters.product_type = typeFilters;
    }
    
    // Get tag filters
    const tagFilters = urlParams.getAll('filter.p.tag');
    if (tagFilters.length > 0) {
      filters.tag = tagFilters;
    }
    
    // Get sort_by
    const sortBy = urlParams.get('sort_by');
    if (sortBy) {
      filters.sort_by = sortBy;
    }
    
    return filters;
  }

  // Build filter URL for fetching products
  function buildFilterURL(baseUrl, filters, page = 1) {
    const url = new URL(baseUrl);
    
    // Clear existing filters
    url.searchParams.delete('filter.p.vendor');
    url.searchParams.delete('filter.p.product_type');
    url.searchParams.delete('filter.p.tag');
    url.searchParams.delete('sort_by');
    url.searchParams.delete('page');
    
    // Add active filters
    if (filters.vendor) {
      filters.vendor.forEach(vendor => {
        url.searchParams.append('filter.p.vendor', vendor);
      });
    }
    if (filters.product_type) {
      filters.product_type.forEach(type => {
        url.searchParams.append('filter.p.product_type', type);
      });
    }
    if (filters.tag) {
      filters.tag.forEach(tag => {
        url.searchParams.append('filter.p.tag', tag);
      });
    }
    
    // Add sort_by
    if (filters.sort_by) {
      url.searchParams.set('sort_by', filters.sort_by);
    }
    
    // Add page
    url.searchParams.set('page', page.toString());
    
    return url.toString();
  }

  // Setup filter container and button
  function setupFilterContainer() {
    const filterContainer = document.getElementById('sh-filtered-products');
    if (!filterContainer) {
      console.error('[sh-filter-system] Filter container #sh-filtered-products not found');
      return null;
    }

    // Show the filter container
    filterContainer.style.display = 'block';

    // Hide color sections and other products
    const colorSections = document.querySelectorAll('[id^="color-"]:not(#sh-filtered-products)');
    colorSections.forEach(section => {
      section.style.display = 'none';
    });

    const otherProducts = document.getElementById('other-products');
    if (otherProducts) {
      otherProducts.style.display = 'none';
    }

    return filterContainer;
  }

  // Load filtered products
  async function loadFilteredProducts(filters) {
    console.log('[sh-filter-system] Loading filtered products:', filters);
    
    const filterContainer = setupFilterContainer();
    if (!filterContainer) return;

    const gridWrapper = filterContainer.querySelector('.js-product-grid-wrapper');
    if (!gridWrapper) {
      console.error('[sh-filter-system] Grid wrapper not found in filter container');
      return;
    }

    // Show loading state
    const existingProducts = gridWrapper.querySelectorAll('.grid__item');
    if (existingProducts.length === 0) {
      // Only show loading if no products exist yet
      gridWrapper.innerHTML = '<div class="loading-state" style="text-align: center; padding: 40px; grid-column: 1 / -1;"><p>Loading products...</p></div>';
    }

    let currentPage = 1;
    let hasMorePages = true;
    let totalProducts = 0;
    let allNewProducts = [];
    const BATCH_SIZE = 12; // Render 12 products at a time
    let renderedCount = 0;

    // Function to render a batch of products
    function renderBatch(products, startIndex, batchSize) {
      const endIndex = Math.min(startIndex + batchSize, products.length);
      const batch = products.slice(startIndex, endIndex);
      
      if (startIndex === 0) {
        // Clear loading state on first batch
        gridWrapper.innerHTML = '';
      }
      
      // Use requestAnimationFrame for smooth rendering
      requestAnimationFrame(() => {
        batch.forEach(product => {
          gridWrapper.appendChild(product);
        });
        
        // Show the color collection wrapper after first batch is rendered
        if (startIndex === 0) {
          const colorCollectionWrapper = document.querySelector('.sh-color-collection-wrapper');
          if (colorCollectionWrapper) {
            colorCollectionWrapper.style.display = 'block';
            colorCollectionWrapper.style.visibility = 'visible';
            console.log('[sh-filter-system] Showing color collection wrapper after first batch');
          }
        }
        
        // Lazy load images for performance
        const newImages = batch.flatMap(product => 
          Array.from(product.querySelectorAll('img[loading="lazy"]'))
        );
        
        if (newImages.length > 0 && 'IntersectionObserver' in window) {
          const imageObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                const img = entry.target;
                if (img.dataset.src) {
                  img.src = img.dataset.src;
                  img.removeAttribute('data-src');
                }
                imageObserver.unobserve(img);
              }
            });
          });
          
          newImages.forEach(img => imageObserver.observe(img));
        }
      });
      
      console.log(`[sh-filter-system] Rendered batch: ${startIndex + 1}-${endIndex} of ${products.length}`);
      
      return endIndex;
    }

    // Function to progressively render products as they're collected
    function scheduleProgressiveRender() {
      if (renderedCount < allNewProducts.length) {
        renderedCount = renderBatch(allNewProducts, renderedCount, BATCH_SIZE);
        
        // Schedule next batch with adaptive timing
        if (renderedCount < allNewProducts.length) {
          const delay = renderedCount < BATCH_SIZE * 2 ? 30 : 50; // Faster for first few batches
          setTimeout(scheduleProgressiveRender, delay);
        }
      }
    }

    // Collect products and render progressively
    while (hasMorePages) {
      try {
        const baseUrl = window.location.origin + window.location.pathname;
        const fetchUrl = buildFilterURL(baseUrl, filters, currentPage);
        
        console.log(`[sh-filter-system] Fetching page ${currentPage}:`, fetchUrl);
        
        const response = await fetch(fetchUrl);
        if (!response.ok) throw new Error('Network response was not ok');
        
        const responseText = await response.text();
        const parser = new DOMParser();
        const fetchedDocument = parser.parseFromString(responseText, 'text/html');
        
        // Find products in the fetched document
        const newProducts = Array.from(fetchedDocument.querySelectorAll('.grid__item[data-product-id]'));
        
        if (newProducts.length === 0) {
          hasMorePages = false;
          console.log(`[sh-filter-system] No more products found on page ${currentPage}`);
        } else {
          // Collect products instead of immediately adding them
          const pageProducts = [];
          newProducts.forEach(product => {
            const productId = product.getAttribute('data-product-id');
            const isDuplicate = allNewProducts.some(p => p.getAttribute('data-product-id') === productId);
            
            if (!isDuplicate) {
              const clonedProduct = product.cloneNode(true);
              allNewProducts.push(clonedProduct);
              pageProducts.push(clonedProduct);
              totalProducts++;
            }
          });
          
          // Start rendering the first batch immediately when we get the first page
          if (currentPage === 1 && pageProducts.length > 0) {
            scheduleProgressiveRender();
          } else if (pageProducts.length > 0) {
            // For subsequent pages, continue progressive rendering
            scheduleProgressiveRender();
          }
          
          console.log(`[sh-filter-system] Collected ${newProducts.length} products from page ${currentPage}`);
          currentPage++;
          
          // Smaller delay since we're rendering progressively
          await new Promise(resolve => setTimeout(resolve, 80));
        }
      } catch (error) {
        console.error(`[sh-filter-system] Error loading page ${currentPage}:`, error);
        hasMorePages = false;
      }
    }

    // Ensure any remaining products are rendered
    if (renderedCount < allNewProducts.length) {
      scheduleProgressiveRender();
    }

    console.log(`[sh-filter-system] Finished loading ${totalProducts} total filtered products`);
  }

  // Check if any filter forms have active selections
  function checkFormFilters() {
    const vendorSelects = document.querySelectorAll('select[name="filter.p.vendor"]');
    const vendorCheckboxes = document.querySelectorAll('input[name="filter.p.vendor"]:checked');
    const otherFilters = document.querySelectorAll('input[name^="filter.p."]:checked, select[name^="filter.p."] option:checked');
    
    return vendorSelects.length > 0 && Array.from(vendorSelects).some(select => select.value) ||
           vendorCheckboxes.length > 0 ||
           otherFilters.length > 0;
  }

  // Hide color system
  function hideColorSystem() {
    const colorCollectionWrapper = document.querySelector('.sh-color-collection-wrapper');
    if (colorCollectionWrapper) {
      colorCollectionWrapper.style.display = 'none';
    }
  }

  // Show color system
  function showColorSystem() {
    const colorCollectionWrapper = document.querySelector('.sh-color-collection-wrapper');
    if (colorCollectionWrapper) {
      colorCollectionWrapper.style.display = 'block';
    }
    hideFilterSystem();
  }

  // Show filter system
  function showFilterSystem() {
    const filterContainer = document.getElementById('sh-filtered-products');
    if (filterContainer) {
      filterContainer.style.display = 'block';
      
      // Show loading state
      const gridWrapper = filterContainer.querySelector('.js-product-grid-wrapper');
      if (gridWrapper && gridWrapper.children.length === 0) {
        gridWrapper.innerHTML = '<div class="loading-state" style="text-align: center; padding: 40px; grid-column: 1 / -1;"><p>Loading products...</p></div>';
      }
    }
  }

  // Hide filter system
  function hideFilterSystem() {
    const filterContainer = document.getElementById('sh-filtered-products');
    if (filterContainer) {
      filterContainer.style.display = 'none';
      
      // Clear products when hiding
      const gridWrapper = filterContainer.querySelector('.js-product-grid-wrapper');
      if (gridWrapper) {
        gridWrapper.innerHTML = '';
      }
    }
  }

  // Initialize filter system
  function initFilterSystem() {
    console.log('[sh-filter-system] Initializing filter system');
    
    // Remove inline filter style - main JS is taking over
    const inlineStyle = document.getElementById('sh-immediate-filter-style');
    if (inlineStyle) {
      inlineStyle.remove();
      console.log('[sh-filter-system] Removed inline filter style - main JS taking over');
    }
    
    // IMMEDIATE: Hide color sections if filters are active (prevent flicker)
    if (hasActiveFilters()) {
      console.log('[sh-filter-system] Filters detected - immediately hiding color collection wrapper');
      
      // Immediately hide the entire color collection wrapper
      const colorCollectionWrapper = document.querySelector('.sh-color-collection-wrapper');
      if (colorCollectionWrapper) {
        colorCollectionWrapper.style.display = 'none';
      }
      
      // Show filter container immediately
      const filterContainer = document.getElementById('sh-filtered-products');
      if (filterContainer) {
        filterContainer.style.display = 'block';
      }
    } else {
      // No filters active - ensure color system is visible
      const colorCollectionWrapper = document.querySelector('.sh-color-collection-wrapper');
      if (colorCollectionWrapper) {
        colorCollectionWrapper.style.display = 'block';
      }
      
      const filterContainer = document.getElementById('sh-filtered-products');
      if (filterContainer) {
        filterContainer.style.display = 'none';
      }
    }
    
    // Check if filters are active on page load
    if (hasActiveFilters()) {
      console.log('[sh-filter-system] Active filters detected on page load');
      const filters = getActiveFilters();
      loadFilteredProducts(filters);
    } else {
      console.log('[sh-filter-system] No active filters - using color system');
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFilterSystem);
  } else {
    initFilterSystem();
  }
})();

// Custom Add to Cart logic for dynamically loaded products
function handleCustomAddToCart(form, button) {
  console.log('Custom Add to Cart: Form submitted:', form);
  console.log('Custom Add to Cart: Button passed:', button);
  if (!form || !button) return;

  // Find the button text span
  const buttonText = button.querySelector('span');
  if (!buttonText) {
    console.log('Custom Add to Cart: ButtonText not found');
    return;
  }

  // Get variant ID
  const idInput = form.querySelector('input[name="id"]');
  console.log('Custom Add to Cart: Variant ID input:', idInput);
  if (!idInput) return;
  const variantId = idInput.value;
  console.log('Custom Add to Cart: Variant ID:', variantId);

  // Button state: Adding...
  button.disabled = true;
  buttonText.textContent = 'Adding...';

  // Build payload
  const payload = {
    items: [
      {
        id: variantId,
        quantity: 1
      }
    ]
  };
  console.log('Custom Add to Cart: Payload:', payload);

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  })
    .then(response => {
      if (!response.ok) throw new Error('Network response was not ok');
      return response.json();
    })
    .then(data => {
      console.log('Custom Add to Cart: Success:', data);
      // Button state: Added!
      buttonText.textContent = 'Added!';
      setTimeout(() => {
        button.disabled = false;
        buttonText.textContent = 'Add to Bag';
      }, 1200);
    })
    .catch(error => {
      console.error('Custom Add to Cart: Add to cart failed:', error);
      button.disabled = false;
      buttonText.textContent = 'Error!';
      setTimeout(() => {
        buttonText.textContent = 'Add to Bag';
      }, 1500);
    });
}

// Attach event delegation for add to cart
if (!window._shCollectionColorCustomAddToCart) {
  window._shCollectionColorCustomAddToCart = true;
  document.addEventListener('click', function(event) {
    // Only handle clicks on .addToCart buttons
    const button = event.target.closest('button.addToCart[type="submit"]');
    if (!button) return;

    // Find the closest form
    const form = button.closest('form[action$="/cart/add"]');
    if (!form) return;

    // Prevent default form submission
    event.preventDefault();

    // Debug logs
    console.log('Custom Add to Cart: Button clicked:', button);
    console.log('Custom Add to Cart: Form found:', form);

    // Call your custom add to cart handler
    handleCustomAddToCart(form, button);
  });
}
